import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BonnetOpenFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M15.3545 10.1201C16.7752 8.9112 17.557 8.27753 18.1357 7.93027C18.4738 7.72741 18.7034 7.64851 18.9305 7.60843C19.1906 7.56252 19.4795 7.55978 20.0002 7.55978V5.75978L19.9536 5.75977C19.4934 5.75968 19.0496 5.7596 18.6177 5.83582C18.1383 5.92042 17.7028 6.0909 17.2096 6.38679C16.3611 6.89593 15.232 7.85201 13.2455 9.5542L10.7439 8.14713C9.80146 7.56596 8.72224 7.25818 7.62109 7.25818L4.04004 7.25896V17.0648L4.04139 17.0613H11.6497C12.9307 20.0008 16.6727 19.3152 17.4014 17.0613H18.1974C19.2436 17.0871 19.9778 16.173 19.9778 15.2466V13.908L19.9774 13.8957C19.6695 11.2924 18.2251 10.6945 15.3545 10.1201Z"
      />
    </SvgIcon>
  );
});
